/**
 * @generated SignedSource<<262dcd1665e2d44222553d04675085ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeTextFormUser$data = {
  readonly account: {
    readonly brands: ReadonlyArray<{
      readonly facebookPages: ReadonlyArray<{
        readonly externalId: string;
        readonly id: string;
        readonly name: string;
        readonly picture: string;
      }>;
      readonly id: string;
      readonly instagramAccounts: ReadonlyArray<{
        readonly externalId: string;
        readonly id: string;
        readonly name: string;
        readonly picture: string;
      }>;
      readonly name: string;
    }>;
  };
  readonly " $fragmentType": "CreativeTextFormUser";
};
export type CreativeTextFormUser$key = {
  readonly " $data"?: CreativeTextFormUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeTextFormUser">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalId",
    "storageKey": null
  },
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "picture",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeTextFormUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Brand",
          "kind": "LinkedField",
          "name": "brands",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FacebookPage",
              "kind": "LinkedField",
              "name": "facebookPages",
              "plural": true,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InstagramAccount",
              "kind": "LinkedField",
              "name": "instagramAccounts",
              "plural": true,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "cba8f6de3fa68d547ea2eb9f5ae3f8a0";

export default node;
